import React, { useEffect, useState } from 'react';
import styles from './player-vod.css';
import { ProgressBar } from '../components/progress-bar';
import { PlaybackStatus } from '../components/playback-status';
import { getUrl } from '../utils/spotlight';
import { coverImagesTypes } from '../constants/types';

export const PlayerVod = ({ logo, image, title, genres }) => {
  const [progress, setProgress] = useState({ value: 0, start: '00:00:00', end: '00:00:00' });
  const playerManager = cast.framework.CastReceiverContext.getInstance().getPlayerManager();

  useEffect(() => {
    playerManager.addEventListener(cast.framework.events.EventType.TIME_UPDATE, onTimeUpdate);

    return () => {
      playerManager.removeEventListener(cast.framework.events.EventType.TIME_UPDATE, onTimeUpdate);
    };
  }, []);

  /**
   * Updates progress information.
   */
  function onTimeUpdate() {
    const start = new Date(null);
    const end = new Date(null);

    start.setSeconds(playerManager.getCurrentTimeSec());
    end.setSeconds(playerManager.getDurationSec());

    setProgress((progress) => ({
      ...progress,
      value: (playerManager.getCurrentTimeSec() * 100) / playerManager.getDurationSec(),
      start: start.toISOString().substr(11, 8),
      end: end.toISOString().substr(11, 8)
    }));
  }

  /**
   * Gets cover measures.
   */
  function getMeasures() {
    switch (image.type) {
      case coverImagesTypes.PortraitArt:
      case coverImagesTypes.OriginalCover:
      case coverImagesTypes.Cover:
        return { height: 168 };
      case coverImagesTypes.LandscapeCover:
      case coverImagesTypes.LandscapeWideCover:
      case coverImagesTypes.VideoFrame:
      case coverImagesTypes.Banner:
      default:
        return { width: 163 };
    }
  }

  return (
    <>
      <div className={styles.informationWrapper}>
        {Object.keys(logo).length > 0 && (
          <div className={styles.logo}>
            <img src={getUrl({ ...logo, width: 67 })} />
          </div>
        )}
        <div className={styles.cover}>
          <img src={getUrl({ ...image, ...getMeasures() })} />
        </div>
        <div className={styles.information}>
          <h1 className={styles.title}>{title}</h1>
          <h2 className={styles.subtitle}>{genres.join(', ')}</h2>
        </div>
      </div>
      <div className={styles.progressWrapper}>
        <PlaybackStatus />
        <div className={styles.progress}>
          <ProgressBar {...progress} />
        </div>
      </div>
    </>
  );
};
